import { REMOVE_FROM_CART } from '../../constants/actions'

const removeFromCart = payload => ({
  type: REMOVE_FROM_CART,
  ...payload,
})

export { removeFromCart }
